<template>
  <div class="d-flex gap-2">
    <div
      v-for="summary in summaries"
      class="rounded bg-light-subtle p-1 text-center"
      :style="{ 'flex-grow': summary.duration.asMinutes() }"
    >
      {{ summary.label }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { type JourneySegmentSummary } from '~/types/fptfTypes'

defineProps<{
  summaries: JourneySegmentSummary[]
}>()
</script>
